import { Pipe, PipeTransform } from '@angular/core';
import { TipoBeneficiario } from 'src/app/core/models/beneficiario/TipoBeneficiario';

@Pipe({
  name: 'tipoBeneficiario',
})
export class TipoBeneficiarioPipe implements PipeTransform {
  transform(value: TipoBeneficiario): unknown {
    switch (value) {
      case TipoBeneficiario.Dependente:
        return 'Dependente';
      default:
        return 'Titular';
    }
  }
}
